import React from "react";
import LocalDateTime from "services/date-converter";
import Chip from "../../../components/Chip";
import StatusPill from "../../components/StatusPill";
import { CHANNEL_LABEL, DELIVERY_STATUS, SKIP_REASON_LABEL } from "../../features/monitor.constants";

// Columns of the Deliveries list. `start` is the row number offset of the current page.
export const getDeliveryColumns = (start) => [
  { key: "id", label: "S.No", width: "70px", sortable: false, render: (row) => <span className="text-xs text-text_muted">{start + row.__index + 1}</span> },
  {
    key: "recipient_name",
    label: "Recipient",
    sortable: true,
    render: (row) => (
      <div className="flex min-w-0 flex-col">
        <span className="truncate font-medium text-text_primary">{row.recipient_name || row.recipient_address || "—"}</span>
        <span className="truncate text-[11px] text-text_muted">{row.recipient_type_key?.startsWith("CC:") ? `CC · ${row.recipient_type_key.slice(3)}` : row.recipient_type_key}</span>
      </div>
    ),
  },
  { key: "channel_key", label: "Channel", sortable: true, render: (row) => <span className="text-xs text-text_secondary">{CHANNEL_LABEL[row.channel_key] ?? row.channel_key}</span> },
  {
    key: "subject",
    label: "Message",
    sortable: false,
    render: (row) => (
      <div className="flex min-w-0 flex-col">
        <span className="max-w-64 truncate text-xs text-text_primary">{row.subject || "—"}</span>
        <span className="truncate text-[11px] text-text_muted">{row.rule?.name ?? `Rule #${row.rule_fid}`}</span>
      </div>
    ),
  },
  {
    key: "step_no",
    label: "Step",
    sortable: true,
    render: (row) => (
      <div className="flex flex-wrap gap-1">
        <Chip tone={row.is_escalation ? "warning" : "default"}>step {row.step_no}</Chip>
        <Chip>send {row.send_no}</Chip>
      </div>
    ),
  },
  {
    key: "status",
    label: "Status",
    sortable: true,
    render: (row) => (
      <div className="flex flex-col items-start gap-0.5">
        <StatusPill status={row.status} map={DELIVERY_STATUS} />
        {row.status === "SKIPPED" && row.skip_reason && <span className="text-[10px] text-text_muted">{SKIP_REASON_LABEL[row.skip_reason] ?? row.skip_reason}</span>}
        {row.status === "FAILED" && <span className="text-[10px] text-text_muted">{row.attempt_count} attempt{row.attempt_count === 1 ? "" : "s"}</span>}
      </div>
    ),
  },
  { key: "sent_at", label: "Sent", sortable: true, render: (row) => (row.sent_at ? <span className="text-xs text-text_secondary"><LocalDateTime utcTime={row.sent_at} /></span> : <span className="text-xs text-text_muted">—</span>) },
  { key: "created_date", label: "Created", sortable: true, render: (row) => <span className="text-xs text-text_secondary"><LocalDateTime utcTime={row.created_date} /></span> },
];
